"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[167],{

/***/ 167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ VideoSliders; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9447);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(4002);
/* harmony import */ var swiper_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(172);
/* harmony import */ var swiper_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5186);
/* harmony import */ var swiper_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2997);
/* harmony import */ var _components_Layout_WrapperDestaque__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(248);
/* harmony import */ var _components_Layout_Title__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9879);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5877);
/* harmony import */ var _hooks_useBreakpoint__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2140);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9659);
/* harmony import */ var _components_Layout_Card__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3666);










swiper_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"].use */ .Z.use([
    swiper_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,
    swiper_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z
]);
function VideoSliders(param) {
    var featuredVideosData = param.featuredVideosData, _isOnProduct = param.isOnProduct, isOnProduct = _isOnProduct === void 0 ? false : _isOnProduct, _setBackgroundColor = param.setBackgroundColor, setBackgroundColor = _setBackgroundColor === void 0 ? "bg-mglGray50" : _setBackgroundColor, _useTitle = param.useTitle, useTitle = _useTitle === void 0 ? true : _useTitle;
    var ref;
    var variants = {
        TituloContent: {
            isOnProduct: {
                true: "max-w-[initial]",
                false: "max-w-[calc(100%-3rem)] tablet:max-w-[83.33%]"
            }
        }
    };
    var currentSpan = (ref = (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_8__/* .getCurrentHub */ .Gd)().getScope()) === null || ref === void 0 ? void 0 : ref.getSpan();
    var videoSlidersSpan = currentSpan && currentSpan.startChild({
        op: "videoSliders"
    });
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_hooks_useBreakpoint__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("phone"), 1), isMobile = ref1[0];
    var pagination = {
        clickable: true
    };
    var navigation = {
        nextEl: "#videos-swiper-button__next",
        prevEl: "#videos-swiper-button__prev"
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Layout_WrapperDestaque__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                backgroundColor: setBackgroundColor || "bg-mglGray50",
                paddingOnlyTop: isOnProduct,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)("mx-auto my-0 w-full", variants.TituloContent.isOnProduct[isOnProduct.toString()]),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout_Title__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            texto: "V\xeddeos",
                            urlRedirect: "/video/",
                            color: "black",
                            showChip: !isOnProduct,
                            alignRight: true
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "relative [&_.container-swiper\\_\\_next]:right-6 [&_.container-swiper\\_\\_prev]:left-6 [&_.container-swiper]:z-[5] [&_.container-swiper]:opacity-100 [&_.container-swiper]:duration-300 [&_.container-swiper]:ease-ease [&_.swiper-pagination]:bottom-0 [&_.swiper-pagination]:pr-[8.333%] [&_.swiper-pagination]:text-right [&_.swiper-pagination-bullet-active.swiper-pagination-bullet]:[&_.swiper-pagination]:w-[26px] [&_.swiper-pagination-bullet-active.swiper-pagination-bullet]:[&_.swiper-pagination]:bg-mglBlue400 [&_.swiper-pagination-bullet-active.swiper-pagination-bullet]:[&_.swiper-pagination]:[transition:background-color_0.3s_0s,_width_0.2s_0.3s] [&_.swiper-pagination-bullet]:[&_.swiper-pagination]:h-2 [&_.swiper-pagination-bullet]:[&_.swiper-pagination]:w-2 [&_.swiper-pagination-bullet]:[&_.swiper-pagination]:rounded-2xl [&_.swiper-pagination-bullet]:[&_.swiper-pagination]:bg-black/20 [&_.swiper-pagination-bullet]:[&_.swiper-pagination]:[transition:background-color_0.3s_0s,_width_0.2s_0.3s]",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_11__/* .Swiper */ .t, {
                                centeredSlidesBounds: true,
                                className: "py-0",
                                centeredSlides: isMobile,
                                grabCursor: true,
                                speed: 1000,
                                pagination: pagination,
                                navigation: navigation,
                                breakpoints: {
                                    0: {
                                        slidesPerView: 1.1,
                                        spaceBetween: 16,
                                        slidesPerGroup: 1
                                    },
                                    530: {
                                        slidesPerView: 2,
                                        spaceBetween: 16,
                                        slidesPerGroup: 2
                                    },
                                    980: {
                                        slidesPerView: isOnProduct ? 3 : 4,
                                        spaceBetween: 16,
                                        slidesPerGroup: isOnProduct ? 3 : 4
                                    }
                                },
                                children: featuredVideosData.map(function(video) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_12__/* .SwiperSlide */ .o, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "relative h-[300px] w-full overflow-hidden rounded-lg",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout_Card__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                title: video.titulo,
                                                image: video.imagem,
                                                url: video.url,
                                                onlyImage: !useTitle,
                                                onlyImageAndText: useTitle,
                                                fullWidth: true
                                            })
                                        })
                                    }, "video-sliders-".concat(video.url));
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "container-swiper container-swiper__prev",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    id: "videos-swiper-button__prev",
                                    className: "swiper-button",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        "aria-hidden": "true",
                                        focusable: "false",
                                        width: "1.5em",
                                        height: "1.5em",
                                        preserveAspectRatio: "xMidYMid meet",
                                        viewBox: "0 0 24 24",
                                        style: {
                                            verticalAlign: "-0.125em",
                                            transform: "rotate(180deg)"
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                            d: "M8.59 16.58L13.17 12L8.59 7.41L10 6l6 6l-6 6l-1.41-1.42z",
                                            fill: "currentColor"
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "container-swiper container-swiper__next",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    id: "videos-swiper-button__next",
                                    className: "swiper-button",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        "aria-hidden": "true",
                                        focusable: "false",
                                        width: "1.5em",
                                        height: "1.5em",
                                        preserveAspectRatio: "xMidYMid meet",
                                        viewBox: "0 0 24 24",
                                        style: {
                                            verticalAlign: "-0.125em",
                                            transform: "rotate(360deg)"
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                            d: "M8.59 16.58L13.17 12L8.59 7.41L10 6l6 6l-6 6l-1.41-1.42z",
                                            fill: "currentColor"
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            videoSlidersSpan && videoSlidersSpan.finish()
        ]
    });
}


/***/ }),

/***/ 3666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Card; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2153);
/* harmony import */ var _components_Layout_Chip__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2384);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9659);





function Card(param) {
    var title = param.title, url = param.url, image = param.image, _chipText = param.chipText, chipText = _chipText === void 0 ? "ver detalhes" : _chipText, _rumor = param.rumor, rumor = _rumor === void 0 ? false : _rumor, _onlyImage = param.onlyImage, onlyImage = _onlyImage === void 0 ? false : _onlyImage, _onlyImageAndText = param.onlyImageAndText, onlyImageAndText = _onlyImageAndText === void 0 ? false : _onlyImageAndText, _fullWidth = param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: url,
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
            className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("group flex min-h-[220px] w-full cursor-pointer flex-col items-center rounded-lg bg-mglGray50 no-underline transition-all duration-300", onlyImage || onlyImageAndText ? "p-0" : "p-4", fullWidth ? "w-full" : ""),
            title: title,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("relative flex aspect-video justify-center [&>figure>div>img]:object-contain", fullWidth ? "w-full" : onlyImageAndText || onlyImage ? "max-h-[240px]" : "max-h-[120px] "),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            src: image.url,
                            blurhash: image.blurhash,
                            width: onlyImage || onlyImageAndText ? null : 100,
                            height: onlyImage || onlyImageAndText ? null : 100,
                            alt: title
                        }),
                        rumor && !onlyImage && !onlyImageAndText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "absolute bottom-[9.5em] left-0 right-0 m-auto w-[3.375rem] rounded-lg bg-[#e8384f] text-center text-[0.6875rem] uppercase leading-loose text-mglGray50 hover:[&>div>span>svg>path>fill]:text-mglGray50",
                            children: "Rumor"
                        })
                    ]
                }),
                onlyImageAndText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    className: "mt-4 font-medium text-mglGray900 tablet:mx-0 tablet:mb-0",
                    children: title
                }),
                !onlyImage && !onlyImageAndText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex h-10 items-center justify-center text-center text-sm font-medium text-mglGray900 no-underline",
                    children: title
                }),
                !onlyImage && !onlyImageAndText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout_Chip__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    texto: chipText,
                    chipSize: "medium",
                    posIcon: "chevron-right",
                    color: "black",
                    borderColor: "black",
                    title: title,
                    className: "group-hover:border group-hover:border-mglGray900 group-hover:bg-mglGray900 group-hover:text-mglGray50 [&>span>svg]:transition-colors group-hover:[&>span>svg]:text-mglGray50"
                })
            ]
        })
    });
}


/***/ }),

/***/ 9879:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Titulo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _Chip__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2384);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9659);



function Titulo(param) {
    var texto = param.texto, color = param.color, urlRedirect = param.urlRedirect, showChip = param.showChip, alignRight = param.alignRight, _headingTag = param.headingTag, headingTag = _headingTag === void 0 ? "h2" : _headingTag, _noPadding = param.noPadding, noPadding = _noPadding === void 0 ? false : _noPadding;
    var titleStyles = "flex items-center text-2xl text-left font-medium";
    var Heading = headingTag;
    var chipProps = {
        black: {
            color: "black",
            border: "black",
            title: "text-mglGray900",
            hover: "black"
        },
        white: {
            color: "white",
            border: "white",
            title: "text-mglGray50",
            hover: "white"
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("flex items-center pb-2 [&>svg]:ml-[5px] [&>svg]:transition-all [&>svg]:duration-200 hover:[&>svg]:ml-[10px]", noPadding && "p-0"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Heading, {
                className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(titleStyles, !alignRight && "mr-2", chipProps[color].title),
                children: texto
            }),
            alignRight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mr-auto"
            }),
            showChip && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Chip__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                texto: "ver tudo",
                color: chipProps[color].color,
                chipSize: "medium",
                posIcon: "chevron-right",
                title: "ver tudo - ".concat(texto),
                borderColor: chipProps[color].border,
                link: urlRedirect,
                hover: chipProps[color].hover
            })
        ]
    });
}


/***/ }),

/***/ 248:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ WrapperDestaque; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9659);


var LEGACY_BG = {
    ctup: "bg-ctupBlue",
    eletro: "bg-cteletroBlack",
    ctauto: "bg-ctautoRed"
};
function WrapperDestaque(param) {
    var children = param.children, _backgroundColor = param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? "bg-mglGray50" : _backgroundColor, isOnHeader = param.isOnHeader, _themeBg = param.themeBg, themeBg = _themeBg === void 0 ? undefined : _themeBg, _editorialCategory = param.editorialCategory, editorialCategory = _editorialCategory === void 0 ? undefined : _editorialCategory, _paddingOnlyTop = param.paddingOnlyTop, paddingOnlyTop = _paddingOnlyTop === void 0 ? false : _paddingOnlyTop;
    var legacyBg = !themeBg && editorialCategory ? LEGACY_BG[editorialCategory] : undefined;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        style: themeBg ? {
            backgroundColor: themeBg
        } : undefined,
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("flex w-full flex-col flex-wrap content-center justify-center p-0 [&_.swiper-container]:w-full [&_.swiper-container]:py-0", isOnHeader && "p-0 py-0", !isOnHeader && !paddingOnlyTop && "p-0 py-6", legacyBg !== null && legacyBg !== void 0 ? legacyBg : backgroundColor, paddingOnlyTop && "p-0 py-0 pt-10", !paddingOnlyTop && "[&_.swiper-container]:px-6"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "ml-0 w-full",
            children: children
        })
    });
}


/***/ })

}]);